module.exports = __webpack_public_path__ + "img/bg_video.92580cbc.png";